import React, { useState } from 'react';
import './index.scss';
import classnames from 'classnames';
import { Card, Justify, Button, Select, Row, Col, Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';

export default function MarketCardContext(props: any) {
  const { data, tipText, isHasYoY = true } = props;

  return Array.isArray(data) ? (
    data?.map((item: any) => (
      <div className={`dbi-marketprofile-cardcontext ${item?.content ? 'cardcontext-cursor' : ''}`}>
        <div className="cardcontext-cont">
          <div className="cardcontext-title">
            {item?.title}
            {tipText ? <TipContext tipText={tipText} /> : ''}
          </div>
          <div className="cardcontext-num">{item?.num}</div>
          <div className="cardcontext-info">
            <div className="cardcontext-text">{item?.text}:</div>
            <Bubble dark content={item?.content} placement="bottom-start">
              <div className={item?.isUp ? 'cardcontext-green' : 'cardcontext-red'}>
                <span>{item?.trend}</span>
                <SvgIcon
                  type={item?.isUp ? 'green-up-new' : 'red-down-new'}
                  className="cardcontext-icon"
                />
              </div>
            </Bubble>
          </div>
        </div>
      </div>
    ))
  ) : (
    <div
      className={classnames('dbi-marketprofile-cardcontext', {
        'cardcontext-cursor': data?.contentm,
        'dbi-marketprofile-cardcontext-noYoY': !isHasYoY,
      })}
    >
      <div className="cardcontext-cont">
        <div className="cardcontext-title">
          {data?.title}
          {tipText ? <TipContext tipText={tipText} /> : ''}
        </div>
        <div className="cardcontext-num">{data?.num}</div>
        {isHasYoY && (
          <div className="cardcontext-info">
            <div className="cardcontext-text">{data?.text}:</div>
            <Bubble dark content={data?.content} placement="bottom-start">
              <div className={data?.isUp ? 'cardcontext-green' : 'cardcontext-red'}>
                <span>{data?.trend}</span>
                <SvgIcon
                  type={data?.isUp ? 'green-up-new' : 'red-down-new'}
                  className="cardcontext-icon"
                />
              </div>
            </Bubble>
          </div>
        )}
      </div>
    </div>
  );
}
